import tinycolor from 'tinycolor2';

module.exports = {
  getNewItem: function (data) {
    var deferred = $.Deferred();

    var newItemData = {
      default_content: data.content,
      family: data.font.family,
      weight: data.font.weight === 'bold' ? 800 : 400,
      size: data.font.size,
      italic: data.font.style === 'italic',
      underline: data.decoration === 'underline',
      paragraph_spacing: data.spacing.paragraph,
      first_line_margin: data.spacing.first_line_margin,
      right_margin: data.spacing.right_margin,
      letter_spacing: data.spacing.letter,
      word_spacing: data.spacing.word,
      line_spacing: data.spacing.line,
      color_code: data.color
    };

    if (data.stroke.width) {
      newItemData.stroke_width = data.stroke.width;
      newItemData.stroke_color = data.stroke.none;
      newItemData.stroke_dasharray = data.stroke.dasharray;
    }

    deferred.resolve(newItemData);

    return deferred.promise();
  },

  isSameModel: function (model1, model2) {
    var colour = tinycolor(model1.color_code).toHexString();
    var content1 = model1.content || model1.name || '';
    var content2 = model2.content || model2.name || '';

    return content1.trim() === content2.trim()
      && model1.size === model2.size
      && model1.family === model2.family
      && model1.color_code.toLowerCase() === model2.color_code.toLowerCase()
      && model1.italic === model2.italic
      && model1.underline === model2.underline;
  }
};
